// تنسيق المبالغ المالية — فواصل آلاف + «ريال»

const nf = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

export const fmtMoney = (n) => nf.format(Number(n) || 0);

export const fmtRiyal = (n) => `${fmtMoney(n)} ريال`;

// "2025-11" → "نوفمبر 2025"
const monthFmt = new Intl.DateTimeFormat('ar-EG', { month: 'long', year: 'numeric' });
export const monthLabel = (ym) => {
  if (!ym) return '—';
  const d = new Date(`${ym}-01T00:00:00`);
  return isNaN(d) ? ym : monthFmt.format(d);
};

export const PAYMENT_AR = {
  paid_full: 'مسدّد بالكامل',
  paid_partial: 'مسدّد جزئياً',
  unpaid: 'غير مسدّد',
  unknown: 'غير محدّد',
};
